import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { MARKETERS_TABLE_ACTIONS, MARKETERS_TABLE_COLUMNS } from '../../constants'
import { TableUrlPagination } from '../../../../ui'
import { TableActions, TableActive } from '../table-actions'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const MarketersTable = () => {
  const intl = useIntl()
  const {
    data,
    search,
    pagination: { total_comercializadoras: totalEntries },
    isLoading,
  } = useSelector((state) => state.marketers)
  const combos = useSelector((state) => state.combos)

  const formattedColumns = useMemo(
    () =>
      [...MARKETERS_TABLE_COLUMNS, ...MARKETERS_TABLE_ACTIONS].map((column) => {
        const baseColumn = {
          accessorKey: column.field,
          header: intl.formatMessage({
            id: `pages.marketers.table.columns.${column.field}.title`,
          }),
          size: column.width,
        }

        if (column.field === 'actions') {
          return {
            ...baseColumn,
            Cell: ({ cell }) => <TableActions cell={cell} />,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
          }
        }

        if (column.field === 'active') {
          return {
            ...baseColumn,
            Cell: ({ cell }) => <TableActive cell={cell} />,
            muiTableBodyCellProps: { align: column.align },
            muiTableHeadCellProps: { align: column.align },
          }
        }

        if (column.comboId && combos[column.comboId]?.data) {
          const lookup = getLookup(combos[column.comboId].data)
          return {
            ...baseColumn,
            Cell: ({ cell }) => {
              const value = cell.getValue()
              return <span>{lookup[value] ?? value ?? '--'}</span>
            },
            muiTableBodyCellProps: { align: column.align || 'left' },
            muiTableHeadCellProps: { align: column.align || 'left' },
          }
        }

        return {
          ...baseColumn,
          Cell: ({ cell }) => <span>{cell.getValue() ?? '--'}</span>,
          muiTableBodyCellProps: { align: column.align || 'left' },
          muiTableHeadCellProps: { align: column.align || 'left' },
        }
      }),
    [combos, intl]
  )

  const tableOptions = useMemo(
    () => ({
      toolbar: false,
      fixedColumns: {
        right: 1,
      },
      draggable: false,
    }),
    []
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={tableOptions}
      totalEntries={totalEntries}
      search={search}
      data={data}
      isLoading={isLoading}
    />
  )
}
